import { takeLatest, select, call, put } from "redux-saga/effects";
import { toast } from "@grandvisionhq/common";
import { getUrlFormatter } from "@grandvisionhq/state";
import { account } from "../../customer-service.js";
import { getAuth } from "../../selectors.js";
import { isLoggedInPasswordless, isUninitialized } from "../../state.js";
import { getToken } from "../../token-service.js";
import { createOptInsUpdate } from "../../Util/Util/create-opt-in-updates.js";
import { SET_PASSWORD, SET_PASSWORD_SUCCESS, SIGNUP, setPasswordSuccess, setPasswordFailed, signUpSuccess, signUpFailed } from "./actions.js";
import { loginWithPassword } from "../../Login/Login/actions.js";
function* activateAccount(action) {
  const authState = yield select(getAuth);
  if (!isLoggedInPasswordless(authState)) {
    throw new Error("User needs to be logged-in with passwordless connection");
  }
  try {
    const token = yield call(getToken, "openid", "email");
    yield call(
      [account, "activate"],
      authState.apiUrl,
      token,
      authState.userId,
      authState.email,
      action.payload.password,
      action.payload.consents
    );
    yield put(
      setPasswordSuccess({
        userId: authState.userId,
        password: action.payload.password,
        email: authState.email,
        consents: action.payload.consents
      })
    );
  } catch (err) {
    yield put(setPasswordFailed(err));
  }
}
function* loginAfterAccountActivation(action) {
  const authState = yield select(getAuth);
  if (!isLoggedInPasswordless(authState)) {
    return;
  }
  try {
    yield put(
      loginWithPassword({
        email: action.payload.email,
        password: action.payload.password
      })
    );
    yield call(toast.success, "account.setPassword.success");
  } catch (err) {
    yield put(setPasswordFailed(err));
  }
}
function* signupPasswordless(action) {
  const authState = yield select(getAuth);
  if (isUninitialized(authState)) {
    throw new Error(`Can't do signup when auth hasn't been initialized first`);
  }
  const formatter = yield call(getUrlFormatter);
  const href = formatter({ route: "auth.callback" });
  try {
    const { email, personalDetails, selectedOptIns, reason } = action.payload;
    const optInUpdates = yield call(createOptInsUpdate, selectedOptIns);
    const { protocol, host } = window.location;
    const redirectUri = `${protocol}//${host}${href}`;
    const result = yield call(
      [account, "signup"],
      authState.apiUrl,
      redirectUri,
      email,
      { personalDetails, optins: optInUpdates },
      reason
    );
    yield put(
      signUpSuccess({
        email: action.payload.email,
        id: result.accountId,
        accountDataToken: result.accountDataToken
      })
    );
    yield call(toast.success, "account.activationEmail.success");
  } catch (err) {
    yield put(signUpFailed(err));
  }
}
const createAccountSagas = [
  takeLatest(SET_PASSWORD, activateAccount),
  takeLatest(SET_PASSWORD_SUCCESS, loginAfterAccountActivation),
  takeLatest(SIGNUP, signupPasswordless)
];
export {
  activateAccount,
  createAccountSagas as default,
  loginAfterAccountActivation,
  signupPasswordless
};
//# sourceMappingURL=sagas.js.map
